"use client";

import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <main className="relative min-h-screen overflow-hidden bg-[#eef4f8] text-slate-900">
      <div className="pointer-events-none absolute -left-28 -top-20 h-72 w-72 rounded-full bg-sky-300/40 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-1/3 h-80 w-80 rounded-full bg-orange-300/35 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-cyan-200/40 blur-3xl" />

      <section className="relative mx-auto flex min-h-screen w-full max-w-5xl items-center px-6 py-14">
        <div className="w-full rounded-3xl border border-white/60 bg-white/75 p-7 shadow-[0_18px_48px_rgba(15,23,42,0.12)] backdrop-blur sm:p-10">
          <p className="mb-3 inline-flex rounded-full bg-sky-100 px-3 py-1 text-xs font-semibold tracking-wide text-sky-800">
            Error 404
          </p>

          <h1 className="text-3xl font-extrabold leading-tight text-slate-900 sm:text-5xl">
            We Could Not Find That Page
          </h1>

          <p className="mt-4 max-w-2xl text-sm text-slate-600 sm:text-base">
            The link may be outdated or the page may no longer be available. Go back to continue where you left off.
          </p>

          <div className="mt-8">
            <button
              type="button"
              onClick={() => router.back()}
              className="inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-sky-700"
            >
              Go Back
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
